import { reducer as form } from "redux-form";
import { profileReducer as profile } from "./modules/profile/reducer";
import { loginReducer as auth } from "./modules/auth/reducer";
import { saveState, loadState } from "../utils/localstorage";
import { throttle } from "lodash";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { sagas } from "./sagas";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedState = loadState();

const rootReducer = combineReducers({
  auth,
  profile,
  form
});

const sagaMiddleware = createSagaMiddleware();

export const configureStore = () => {
  const store = createStore(
    rootReducer,
    persistedState,
    composeEnhancers(
      applyMiddleware(sagaMiddleware)
    )
  );

  sagaMiddleware.run(sagas);

  store.subscribe(
    throttle(() => {
      saveState({
        loggedIn: store.getState().loggedIn,
        profile: store.getState().profile
      });
    }),
    1000
  );

  return store;
};
